<template>
  <div id="app">
    <div v-if="isLogged" class="header header--min">
      <div class="container">
        <div class="row d-flex align-items-center">
          <div class="col-6">
            <h1>
              <router-link :to="{ name: 'firstStep' }">promobox</router-link>
            </h1>
          </div>
          <div class="col-6">
            <div class="header__id">
              <router-link :to="{ name: 'auth' }">Выйти</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="header">
      <div class="container">
        <div class="row d-flex align-items-center">
          <div class="col-md-12">
            <h1>
              <router-link :to="{ name: 'auth' }">promobox</router-link>
            </h1>
          </div>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import $backend from './backend'

export default {
  created () {
    window.setInterval(() => {
      this.sendPosition()
    }, 10000)
  },
  computed: {
    isLogged () {
      return this.$store.state.isLogged
    }
  },
  methods: {
    timestamp () {
      let now = new Date()
      let localOffset = (-1) * now.getTimezoneOffset() * 60000
      let stamp = Math.round((now.getTime() + localOffset) / 1000)
      return stamp
    },
    sendPosition () {
      if (!this.isLogged) {
        return
      }
      const options = {
        enableHighAccuracy: true,
        timeout: 8000,
        maximumAge: 0
      }
      this.$getLocation(options).then(coords => {
        const data = {
          'latitude': coords.lat,
          'longitude': coords.lng,
          'timestamp': this.timestamp()
        }
        $backend.postData('points/position', data)
      })
    }
  }
}
</script>

<style lang="scss">
@import 'assets/sass/main.scss';
</style>
